import React, { memo, useState } from 'react';
import mova from 'mova';
import Popup from "@components/feedback/Popup/Popup";
import RadioButton from "@components/inputs/RadioButton/RadioButton";
import SelectQuantity from "@components/display/SelectQuantity/SelectQuantity";
import moment from 'moment';
import currency from '@filters/currency';
import { clone } from "@utils/lo/lo";

const t = mova.ns('containers.SelectSpotModal');

const getTypePrice = (type, date) => type[moment(date).isoWeekday()];

const SelectDepositTypePopup = ({ data, typeSelected, onClose, date }) => {
  const { deposit, x, y } = data;
  const [selectedType, setSelectedType] = useState(deposit.types.length === 1 ? deposit.types[0] : null);
  const [quantity, setQuantity] = useState(1);

  const handleTypeSelect = (type) => {
    setSelectedType(type);
  };

  const handleQuantityChange = (newQuantity) => {
    setQuantity(newQuantity);
  };

  const handleConfirm = () => {
    if (selectedType) {
      typeSelected(selectedType, quantity);
    }
  };

  const shouldShowQuantity = !deposit.disableQuantity;

  return (
    <Popup className='deposit-type-popup' open closing={false} style={{ left: x, top: y }} onClose={onClose}>
      <div>{t('selectDepositType')}:</div>

      {clone(deposit.types).sort((t1, t2) => t1.id - t2.id).map(type => (
        <div key={type.id} onClick={() => handleTypeSelect(type)} className='deposit-type-popup__row'>
          <div className='deposit-type-popup__left'>
            <RadioButton
              style={{ flexShrink: 0 }}
              checked={selectedType?.id === type.id}
            />
            <div className='deposit-type-popup__type-name'>{type.label}</div>
          </div>
          <div className='deposit-type-popup__price'>{currency(getTypePrice(type, date))}</div>
        </div>
      ))}

      {shouldShowQuantity && (
        <div className='deposit-type-popup__quantity-row'>
          <div className='deposit-type-popup__quantity-label'>{t('quantity')}:</div>
          <SelectQuantity
            selected={quantity}
            setSelected={handleQuantityChange}
            disableRemove={false}
          />
        </div>
      )}

      <div className='deposit-type-popup__confirm'>
        <button
          className='deposit-type-popup__confirm-button'
          onClick={handleConfirm}
          disabled={!selectedType}
        >
          {t('confirm')}
        </button>
      </div>
    </Popup>
  );
};

export default memo(SelectDepositTypePopup);
